<template>
  <div :class="card?'card-table':''">
    <table :id="tableId" class="table" ref="table">
      <div v-if="card" class="sort-btn"><span>به ترتیب: </span><strong></strong></div>
      <thead>
      <tr>
        <th :key="index" v-for="(header,index) in headers">{{ header }}</th>
      </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>
</template>

<script>
import store from "@/store";
import {getTableHeaders} from "@/shared/helper";

export default {
  mounted()
  {
    window.currentComponent = this;
    this.initiatedPath = this.$route.path;
    const language = {
      language: {
        "emptyTable": "هیچ داده‌ای در جدول وجود ندارد",
        "info": "نمایش _START_ تا _END_ از _TOTAL_ ردیف",
        "infoEmpty": "نمایش 0 تا 0 از 0 ردیف",
        "infoFiltered": "(فیلتر شده از _MAX_ ردیف)",
        "infoThousands": ",",
        "lengthMenu": "_MENU_",
        "processing": "در حال پردازش...",
        "search": "",
        "zeroRecords": "رکوردی با این مشخصات پیدا نشد",
        paginate: {
          previous: '<i class="fa fa-angle-right" aria-hidden="true">',
          next: '<i class="fa fa-angle-left" aria-hidden="true"></i></i>'
        },
        "aria": {
          "sortAscending": ": فعال سازی نمایش به صورت صعودی",
          "sortDescending": ": فعال سازی نمایش به صورت نزولی"
        },
        "autoFill": {
          "cancel": "انصراف",
          "fill": "پر کردن همه سلول ها با ساختار سیستم",
          "fillHorizontal": "پر کردن سلول های افقی",
          "fillVertical": "پرکردن سلول های عمودی",
          "info": "نمونه اطلاعات پرکردن خودکار"
        },
        "buttons": {
          "collection": "مجموعه",
          "colvis": "قابلیت نمایش ستون",
          "colvisRestore": "بازنشانی قابلیت نمایش",
          "copy": "کپی",
          "copySuccess": {
            "1": "یک ردیف داخل حافظه کپی شد",
            "_": "%ds ردیف داخل حافظه کپی شد"
          },
          "copyTitle": "کپی در حافظه",
          "excel": "اکسل",
          "pageLength": {
            "-1": "نمایش همه ردیف‌ها",
            "1": "نمایش 1 ردیف",
            "_": "نمایش %d ردیف"
          },
          "print": "چاپ",
          "copyKeys": "برای کپی داده جدول در حافظه سیستم کلید های ctrl یا ⌘ + C را فشار دهید",
          "csv": "فایل CSV",
          "pdf": "فایل PDF"
        },
        "searchBuilder": {
          "add": "افزودن شرط",
          "button": {
            "0": "جستجو ساز",
            "_": "جستجوساز (%d)"
          },
          "clearAll": "خالی کردن همه",
          "condition": "شرط",
          "conditions": {
            "date": {
              "after": "بعد از",
              "before": "بعد از",
              "between": "میان",
              "empty": "خالی",
              "equals": "برابر",
              "not": "نباشد",
              "notBetween": "میان نباشد",
              "notEmpty": "خالی نباشد"
            },
            "number": {
              "between": "میان",
              "empty": "خالی",
              "equals": "برابر",
              "gt": "بزرگتر از",
              "gte": "برابر یا بزرگتر از",
              "lt": "کمتر از",
              "lte": "برابر یا کمتر از",
              "not": "نباشد",
              "notBetween": "میان نباشد",
              "notEmpty": "خالی نباشد"
            },
            "string": {
              "contains": "حاوی",
              "empty": "خالی",
              "endsWith": "به پایان می رسد با",
              "equals": "برابر",
              "not": "نباشد",
              "notEmpty": "خالی نباشد",
              "startsWith": "شروع  شود با"
            },
            "array": {
              "equals": "برابر",
              "empty": "خالی",
              "contains": "حاوی",
              "not": "نباشد",
              "notEmpty": "خالی نباشد",
              "without": "بدون"
            }
          },
          "data": "اطلاعات",
          "deleteTitle": "حذف عنوان",
          "logicAnd": "و",
          "logicOr": "یا",
          "title": {
            "0": "جستجو ساز",
            "_": "جستجوساز (%d)"
          },
          "value": "مقدار"
        },
        "select": {
          "1": "%d ردیف انتخاب شد",
          "_": "%d ردیف انتخاب شد",
          "cells": {
            "1": "1 سلول انتخاب شد",
            "_": "%d سلول انتخاب شد"
          },
          "columns": {
            "1": "یک ستون انتخاب شد",
            "_": "%d ستون انتخاب شد"
          },
          "rows": {
            "0": "%d ردیف انتخاب شد",
            "1": "1ردیف انتخاب شد",
            "_": "%d  انتخاب شد"
          }
        },
        "thousands": ",",
        "decimal": "اعشاری",
        "searchPanes": {
          "clearMessage": "همه را پاک کن",
          "collapse": {
            "0": "صفحه جستجو",
            "_": "صفحه جستجو (٪ d)"
          },
          "count": "{total}",
          "countFiltered": "{shown} ({total})",
          "emptyPanes": "صفحه جستجو وجود ندارد",
          "loadMessage": "در حال بارگیری صفحات جستجو ...",
          "title": "فیلترهای فعال - %d"
        },
        "loadingRecords": "در حال بارگذاری...",
        "datetime": {
          "previous": "قبلی",
          "next": "بعدی",
          "hours": "ساعت",
          "minutes": "دقیقه",
          "seconds": "ثانیه",
          "amPm": [
            "صبح",
            "عصر"
          ]
        },
        "editor": {
          "close": "بستن",
          "create": {
            "button": "جدید",
            "title": "ثبت جدید",
            "submit": "ایجــاد"
          },
          "edit": {
            "button": "ویرایش",
            "title": "ویرایش",
            "submit": "به‌روزرسانی"
          },
          "remove": {
            "button": "حذف",
            "title": "حذف",
            "submit": "حذف"
          },
          "multi": {
            "restore": "واگرد"
          }
        }
      }
    }

    let serverSide = {};
    if (this.route)
    {
      const authData = store.getters["auth/getAuthData"];
      serverSide = {
        processing: true,
        "serverSide": true,
        "ajax": {
          url: process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH + this.route,
          type: "GET",
          headers: {'Authorization': `bearer ${authData.token}`},
        }
      };
    }
    const self = this;
    const rows = this.datas || [];

    const $ = window.$;
    $(document).ready(function ()
    {
      self.table = $('#'+self.tableId).DataTable({
        dom: "<'row'<'select-menu'l><'search'f>>" +
            "<'table-responsive'tr>" +
            "<'row'<'col-sm-5'i><'col-sm-7'p>>",
        data: rows,
        "order": [[self.orderBy?self.orderBy:0,self.orderType?self.orderType:'desc']],
        responsive: true,
        drawCallback:self.drawCallback,
        ...language,
        ...serverSide
      });
      $(this).delegate('.method', 'click', function ()
      {
        const methodName = $(this).data('name');
        let methodParams = $(this).data('params');
        if (!methodParams)
          methodParams = [];
        else
          methodParams = methodParams.split('|');

        if (self.functions && Array.isArray(self.functions))
        {
          for (let i=0;i<self.functions.length;i++)
          {
            const a = self.functions[i];
            if (a.name === methodName && typeof a.method ==="function")
            {
              a.method(...methodParams);
            }
          }
        }
      });
    })
  },
  data:function (){
    return {
      initiatedPath:'',
      tableId:'table-id-'+(new Date().getTime()),
      table:null
    }
  },
  beforeUnmount:function ()
  {
    // if (this.table)
    // {
    //   this.table.destroy();
    // }
  },
  methods:{
    drawCallback()
    {
      const showLastLabel = this.showLastLabel;
      const $ = window.$;
      const headers = getTableHeaders($('#'+this.tableId));
      $('#'+this.tableId+' tbody tr').each(function (){
        let i = 0;

        let n = $(this).find('td').length;
        $(this).find('td').each(function (){
          if (i>=(n-1) && !showLastLabel)
            return;
          $(this).html('<span class="td-title">'+headers[i]+':</span> '+$(this).html());
          i++;
        })
      })
    },
    reload()
    {
      if (this.table)
      {
        this.table.clear().draw();
        this.table.rows = this.datas;
        this.table.columns.adjust().draw()
      }
    },
    reInit()
    {
      const url= `${process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH +this.route}`;
      this.table.ajax.url(url).load();
    }
  },
  watch:{
    "$route.path":{
      handler(url,oldUrl)
      {
        if (url.indexOf(this.initiatedPath)>=0)
        {
          window.currentComponent = this;
          if (this.autoReload)
          {
            if (this.table.ajax)
              this.table.ajax.reload();
            else
              this.table.clear().draw();
          }
        }
        else if (oldUrl.indexOf(this.initiatedPath)>=0 && this.table)
        {
          console.log('clearing table')
          this.table.clear();
          window.$('#'+this.tableId+' tbody').html('');
        }
      }
    },
    route()
    {
      if (this.table)
      {
        this.table.ajax.url(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH +this.route).load()
      }
    }
  },
  props: ['headers', 'datas', 'route','functions','autoReload','card','orderBy','orderType','showLastLabel'],
  name: "DataTable"
}
</script>

<style scoped>
.td-title {
  font-weight: bold;
  color: #5a5a5a;
}
</style>
